import Lightning from '@lightningjs/sdk/src/Lightning';
import {
  HoverableComponent,
  HoverableComponentTypeConfig,
} from 'components/common/HoverableComponent';

export interface HoverableListItemTemplateSpec
  extends Lightning.Component.TemplateSpec {
  isItemHover: boolean;
}

export class HoverableListItem<
  TemplateSpec extends Lightning.Component.TemplateSpec = HoverableListItemTemplateSpec,
  TypeConfig extends Lightning.Component.TypeConfig &
    HoverableComponentTypeConfig = Lightning.Component.TypeConfig &
    HoverableComponentTypeConfig,
> extends HoverableComponent<TemplateSpec, TypeConfig> {
  collectionWrapper: any; // set by CollectionWrapper
  itemIndex: any; // set by CollectionWrapperWithSpeech

  _isItemHover = false;

  get isItemHover() {
    return this._isItemHover;
  }

  set isItemHover(value: boolean) {
    this._isItemHover = value;
  }

  override _setup() {
    super._setup();
  }

  override _handleHover(target: any) {
    if (!this.isHoverable) {
      return true;
    }

    if (this.collectionWrapper) {
      if (this.isItemHover) {
        this.hovered = true;
        return false;
      }

      this.collectionWrapper.isHovered = true;
      this.collectionWrapper.index = this.itemIndex;
    }

    return super._handleHover(target);
  }

  override _handleUnhover(target: any) {
    if (!this.isHoverable) {
      return true;
    }

    if (this.collectionWrapper) {
      if (this.isItemHover) {
        this.hovered = false;
        return false;
      }

      this.collectionWrapper.isHovered = false;
    }

    return super._handleUnhover(target);
  }
}
